// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a78deed8","455":"e3da32e9","977":"5b769062"}[chunkId] + ".chunk.js";
};